import axios, {AxiosResponse} from 'axios'

// List regulationCategory
const regulationCategoryList = async ({params}) => {
  const response = await axios.get('/api/regulation-category/list', params)
  return response.data
}

// Create Or Update new regulationCategory
const regulationCategoryCreate = async ({data}) => {
  await axios.post('/api/regulation-category/store', data)
}

// Edit regulationCategory
const regulationCategoryEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/regulation-category/edit/${id}`)
  return response.data
}

// Delete regulationCategory
const regulationCategoryDelete = async (id: string) => {
  await axios.get(`/api/regulation-category/destroy/${id}`)
}

// List regulation
const regulationList = async ({params}) => {
  const response = await axios.get('/api/regulation/list', params)
  return response.data
}

// Create Or Update new regulation
const regulationCreate = async ({data}) => {
  await axios.post('/api/regulation/store', data)
}

// Edit regulation
const regulationEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/regulation/edit/${id}`)
  return response.data
}

// View regulation
const regulationView = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/regulation/view/${id}`)
  return response.data
}

// Delete regulation
const regulationDelete = async (id: string) => {
  await axios.get(`/api/regulation/destroy/${id}`)
}

const regulationService = {
  regulationCategoryList,
  regulationCategoryCreate,
  regulationCategoryEdit,
  regulationCategoryDelete,
  regulationList,
  regulationCreate,
  regulationEdit,
  regulationDelete,
  regulationView,
}

export default regulationService
